<template>
  <a-modal
    :open="open"
    title="Editar nombre de parámetro"
    okText="Guardar cambios"
    centered
    @ok="handleOk"
    @cancel="handleClose"
  >
    <section>
      <p>
        Este nombre se actualizará en los lugares donde se hayan usado en tu plantilla. 
        Recuerda que, si descargaste tu Excel con Parámetros desde estrategias, deberás 
        volverlo a descargar con esta actualización. 
      </p>

      <a-form class="form" ref="formRef" layout="vertical" :model="formState">
        <a-form-item name="name" label="Nombre del parámetro" :rules="nameRules">
          <a-input class="input" v-model:value="formState.name" placeholder="Escribir aquí..." />
        </a-form-item>
      </a-form>

      <p class="info">
        El nombre debe ser en minúsculas, separados por un guion bajo, sin espacios y sin caracteres
        especiales. Ejemplo: producto_123
      </p>
    </section>
  </a-modal>
</template>

<script setup lang="ts">
import { reactive } from "vue";

import { Template, Variable } from "@/@types/flows/emailTemplates";
import { variableNameRegex } from "@/app/flows/emailTemplates/utils/regex";
import { message } from "ant-design-vue";
import { variablesService } from "@/app/flows/emailTemplates/services/Variables.service";

const nameRules = [
  { required: true, message: "El nombre es requerido" },
  {
    pattern: variableNameRegex,
    message: "El nombre no cumple con los parámetros",
  },
];

const props = defineProps<{
  template: Template | undefined;
  open: boolean;
  variable: Variable & { idx: number };
}>();

const emit = defineEmits<{ "update:open": [open: boolean]; update: [] }>();

const formState: { name: string } = reactive({ name: props.variable.name });

const handleClose = () => emit("update:open", false);

const handleOk = async () => {
  try {
    if (!props.template) return;

    await variablesService.edit(props.template, props.variable.idx, formState);
    message.success("Se editó el nombre correctamente");
    emit("update");
    handleClose();
  } catch (error) {
    message.error("Ha ocurrido un error");
    console.error(error);
  }
};
</script>

<style scoped lang="sass">
p
  color: $gray-8
  margin-bottom: 24px

  &.info
    margin: 0
    margin-top: 2px
    color: $text-tertiary
    text-wrap: pretty

.ant-form-item
  margin: 0

section
  padding: 20px 16px
</style>
